(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var isPC = function () {
      return window.matchMedia('(min-width: 800px)').matches;
    };

    /* --- PC: inert / aria-hidden を解除してフィルタを操作可能にする --- */
    function initFilterState() {
      document.querySelectorAll('.p-index-filter').forEach(function (filter) {
        if (isPC()) {
          filter.removeAttribute('inert');
          filter.removeAttribute('aria-hidden');
        } else {
          if (filter.getAttribute('aria-hidden') !== 'false') {
            filter.setAttribute('inert', '');
            filter.setAttribute('aria-hidden', 'true');
          }
        }
      });

      /* PC: criteria のアコーディオンを全て開く */
      document.querySelectorAll('.p-index-filter-body .criteria').forEach(function (c) {
        if (isPC()) {
          c.removeAttribute('aria-hidden');
        }
      });
    }

    initFilterState();
    window.addEventListener('resize', initFilterState);

    /* --- フィルタ開閉（モバイル） --- */
    document.querySelectorAll('.js-filter-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var section = trigger.closest('.p-index');
        var filter = section && section.querySelector('.p-index-filter');
        if (!filter) return;
        filter.setAttribute('aria-hidden', 'false');
        filter.removeAttribute('inert');
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('.js-filter-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.closest('.p-index-filter');
        if (!filter) return;
        filter.setAttribute('aria-hidden', 'true');
        filter.setAttribute('inert', '');
        document.body.style.overflow = '';
      });
    });

    /* --- モバイル: 各 criteria アコーディオン --- */
    document.querySelectorAll('.p-index-filter-body .criteria > .title').forEach(function (title) {
      title.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 800px)').matches) return;
        var c = title.closest('.criteria');
        if (!c) return;
        var isOpen = c.getAttribute('aria-hidden') === 'false';
        c.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      });
    });

    /* --- タブ（商品タイプフィルタ） --- */
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-collection-tab]');
      if (!tab) return;
      e.preventDefault();

      var url = new URL(window.location.href);
      url.searchParams.delete('filter.p.product_type');
      url.searchParams.delete('page');

      var filterValue = tab.getAttribute('data-filter-value');
      if (filterValue) {
        url.searchParams.set('filter.p.product_type', filterValue);
      }
      window.location.href = url.toString();
    });

    /* --- ソート --- */
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-collection-sort]');
      if (!select) return;

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    /* --- フィルタフォーム送信 --- */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.p-index-filter-form');
      if (!form) return;
      e.preventDefault();

      /* キーワード検索の入力値を取得 */
      var searchInput = form.querySelector('[data-sidebar-search-input]');
      var searchQuery = searchInput ? searchInput.value.trim() : '';

      /* キーワードがあれば検索ページ、なければコレクションページ */
      var indexEl = document.querySelector('.p-index[data-collection-url]');
      var collectionUrl = indexEl ? indexEl.getAttribute('data-collection-url') : window.location.pathname;
      var baseUrl;
      if (searchQuery) {
        baseUrl = new URL('/search', window.location.origin);
        baseUrl.searchParams.set('q', searchQuery);
        baseUrl.searchParams.set('type', 'product');
      } else {
        baseUrl = new URL(collectionUrl, window.location.origin);
      }

      /* 商品タイプタブのフィルタを維持 */
      var currentUrl = new URL(window.location.href);
      var typeFilter = currentUrl.searchParams.get('filter.p.product_type');
      if (typeFilter) baseUrl.searchParams.set('filter.p.product_type', typeFilter);

      /* フォームデータからフィルタパラメータを構築 */
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        if (!value) return;
        if (key === 'sort_by') {
          baseUrl.searchParams.set(key, value);
        } else if (key === 'price_preset') {
          /* プリセットは送信しない（数値入力で送る） */
        } else if (key.startsWith('filter.v.price')) {
          /* 価格は ¥ やカンマを除去して数値で送信 */
          var num = String(value).replace(/[¥,\s]/g, '');
          if (num && num !== '0') baseUrl.searchParams.append(key, num);
        } else if (key.startsWith('filter.')) {
          baseUrl.searchParams.append(key, value);
        }
      });

      /* モバイルフィルタを閉じる */
      var filter = form.closest('.p-index-filter');
      if (filter) {
        filter.setAttribute('aria-hidden', 'true');
        filter.setAttribute('inert', '');
        document.body.style.overflow = '';
      }

      window.location.href = baseUrl.toString();
    });

    /* --- フィルタリセット（常にコレクションページへ） --- */
    function resetAllFilters() {
      var indexEl = document.querySelector('.p-index[data-collection-url]');
      var collectionUrl = indexEl ? indexEl.getAttribute('data-collection-url') : window.location.pathname;
      window.location.href = collectionUrl;
    }

    document.querySelectorAll('.js-filter-reset').forEach(function (btn) {
      btn.addEventListener('click', resetAllFilters);
    });

    /* リセットボタン（モバイルヘッダー内） */
    document.querySelectorAll('.p-index-filter-form').forEach(function (form) {
      form.addEventListener('reset', function (e) {
        e.preventDefault();
        resetAllFilters();
      });
    });

    /* --- 価格帯スライダー + 入力連動 --- */
    document.querySelectorAll('[data-price-range]').forEach(function (container) {
      var minThumb = container.querySelector('[data-range-thumb="min"]');
      var maxThumb = container.querySelector('[data-range-thumb="max"]');
      var minInput = container.querySelector('[data-price-min]');
      var maxInput = container.querySelector('[data-price-max]');
      var fill = container.querySelector('[data-range-fill]');
      var rangeMax = parseInt(container.dataset.rangeMax) || 800000;

      function formatYen(v) {
        return '¥' + Number(v).toLocaleString();
      }
      function parseYen(s) {
        return parseInt(String(s).replace(/[¥,\s]/g, '')) || 0;
      }

      function updateFill() {
        var lo = parseInt(minThumb.value);
        var hi = parseInt(maxThumb.value);
        var pctLo = (lo / rangeMax) * 100;
        var pctHi = (hi / rangeMax) * 100;
        fill.style.left = pctLo + '%';
        fill.style.right = 100 - pctHi + '%';
      }

      function syncFromSliders() {
        var lo = parseInt(minThumb.value);
        var hi = parseInt(maxThumb.value);
        if (lo > hi) {
          var t = lo;
          lo = hi;
          hi = t;
        }
        minInput.value = formatYen(lo);
        maxInput.value = formatYen(hi);
        updateFill();
      }

      minThumb.addEventListener('input', syncFromSliders);
      maxThumb.addEventListener('input', syncFromSliders);

      /* テキスト入力 → スライダー連動 */
      minInput.addEventListener('change', function () {
        var v = parseYen(minInput.value);
        minThumb.value = v;
        minInput.value = formatYen(v);
        updateFill();
      });
      maxInput.addEventListener('change', function () {
        var v = parseYen(maxInput.value);
        maxThumb.value = v;
        maxInput.value = formatYen(v);
        updateFill();
      });

      /* 初期状態 */
      updateFill();
    });

    /* --- 価格帯プリセット → スライダー + 入力連動（複数選択） --- */
    document.querySelectorAll('[data-price-preset]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var criteria = cb.closest('.criteria');
        if (!criteria) return;
        var container = criteria.querySelector('[data-price-range]');
        if (!container) return;
        var minInput = container.querySelector('[data-price-min]');
        var maxInput = container.querySelector('[data-price-max]');
        var minThumb = container.querySelector('[data-range-thumb="min"]');
        var maxThumb = container.querySelector('[data-range-thumb="max"]');
        var rangeMax = parseInt(container.dataset.rangeMax) || 800000;

        /* 「すべて」チェック時は他を解除 */
        if (cb.value === 'all' && cb.checked) {
          criteria.querySelectorAll('[data-price-preset]').forEach(function (other) {
            if (other !== cb) other.checked = false;
          });
          minThumb.value = 0;
          maxThumb.value = rangeMax;
        } else {
          /* 「すべて」以外をチェックしたら「すべて」を解除 */
          var allCb = criteria.querySelector('[data-price-preset][value="all"]');
          if (allCb) allCb.checked = false;

          /* チェック済みプリセットの min/max をマージ */
          var checked = criteria.querySelectorAll('[data-price-preset]:checked');
          if (checked.length === 0) {
            minThumb.value = 0;
            maxThumb.value = rangeMax;
          } else {
            var lo = Infinity,
              hi = 0;
            checked.forEach(function (c) {
              var parts = c.value.split('-');
              var pMin = parts[0] ? Math.round(parseInt(parts[0]) / 100) : 0;
              var pMax = parts[1] ? Math.round(parseInt(parts[1]) / 100) : rangeMax;
              if (pMin < lo) lo = pMin;
              if (pMax > hi) hi = pMax;
            });
            minThumb.value = lo;
            maxThumb.value = hi;
          }
        }

        minInput.value = '¥' + Number(minThumb.value).toLocaleString();
        maxInput.value = '¥' + Number(maxThumb.value).toLocaleString();

        var fill = container.querySelector('[data-range-fill]');
        if (fill) {
          fill.style.left = (parseInt(minThumb.value) / rangeMax) * 100 + '%';
          fill.style.right = 100 - (parseInt(maxThumb.value) / rangeMax) * 100 + '%';
        }
      });
    });

    /* --- サイズスライダー連動 --- */
    document.querySelectorAll('[data-size-range]').forEach(function (container) {
      var minThumb = container.querySelector('[data-range-thumb="min"]');
      var maxThumb = container.querySelector('[data-range-thumb="max"]');
      var minInput = container.querySelector('[data-size-min-input]');
      var maxInput = container.querySelector('[data-size-max-input]');
      var fill = container.querySelector('[data-range-fill]');
      var hiddenContainer = container.querySelector('[data-size-hidden-inputs]');
      var valuesJson = container.querySelector('[data-size-values]');
      var paramName = container.dataset.paramName;
      var rangeMin = parseInt(container.dataset.rangeMin) || 0;
      var rangeMax = parseInt(container.dataset.rangeMax) || 1000;
      var availableValues = [];

      try {
        availableValues = JSON.parse(valuesJson.textContent);
      } catch (e) {}

      function updateFill() {
        var lo = parseInt(minThumb.value);
        var hi = parseInt(maxThumb.value);
        if (lo > hi) {
          var t = lo;
          lo = hi;
          hi = t;
        }
        var pctLo = ((lo - rangeMin) / (rangeMax - rangeMin)) * 100;
        var pctHi = ((hi - rangeMin) / (rangeMax - rangeMin)) * 100;
        fill.style.left = pctLo + '%';
        fill.style.right = 100 - pctHi + '%';
      }

      function updateHiddenInputs() {
        var lo = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
        var hi = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
        hiddenContainer.innerHTML = '';
        availableValues.forEach(function (v) {
          if (v >= lo && v <= hi) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = paramName;
            input.value = v;
            hiddenContainer.appendChild(input);
          }
        });
      }

      function syncFromSliders() {
        var lo = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
        var hi = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
        minInput.value = lo;
        maxInput.value = hi;
        updateFill();
        updateHiddenInputs();
      }

      minThumb.addEventListener('input', syncFromSliders);
      maxThumb.addEventListener('input', syncFromSliders);

      minInput.addEventListener('change', function () {
        var v = parseInt(minInput.value) || rangeMin;
        minThumb.value = v;
        syncFromSliders();
      });
      maxInput.addEventListener('change', function () {
        var v = parseInt(maxInput.value) || rangeMax;
        maxThumb.value = v;
        syncFromSliders();
      });

      updateFill();
    });

    /* --- 総エディションスライダー + チェックボックス連動 --- */
    document.querySelectorAll('[data-edition-range]').forEach(function (container) {
      var minThumb = container.querySelector('[data-range-thumb="min"]');
      var maxThumb = container.querySelector('[data-range-thumb="max"]');
      var minInput = container.querySelector('[data-edition-min-input]');
      var maxInput = container.querySelector('[data-edition-max-input]');
      var fill = container.querySelector('[data-range-fill]');
      var hiddenContainer = container.querySelector('[data-edition-hidden-inputs]');
      var valuesJson = container.querySelector('[data-edition-values]');
      var paramName = container.dataset.paramName;
      var rangeMin = parseInt(container.dataset.rangeMin) || 0;
      var rangeMax = parseInt(container.dataset.rangeMax) || 1000;
      var availableValues = [];
      /* チェックボックスは同じ .body 内にある */
      var body = container.closest('.body');
      var presetCheckboxes = body ? body.querySelectorAll('[data-edition-preset]') : [];

      try {
        availableValues = JSON.parse(valuesJson.textContent);
      } catch (e) {}

      function updateFill() {
        var lo = parseInt(minThumb.value);
        var hi = parseInt(maxThumb.value);
        if (lo > hi) {
          var t = lo;
          lo = hi;
          hi = t;
        }
        var pctLo = ((lo - rangeMin) / (rangeMax - rangeMin)) * 100;
        var pctHi = ((hi - rangeMin) / (rangeMax - rangeMin)) * 100;
        fill.style.left = pctLo + '%';
        fill.style.right = 100 - pctHi + '%';
      }

      function updateHiddenInputs() {
        var lo = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
        var hi = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
        hiddenContainer.innerHTML = '';
        availableValues.forEach(function (v) {
          if (v >= lo && v <= hi) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = paramName;
            input.value = v;
            hiddenContainer.appendChild(input);
          }
        });
      }

      /* チェックボックスの checked 状態をスライダー範囲に合わせて更新 */
      function syncPresetsFromSliders() {
        var lo = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
        var hi = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
        presetCheckboxes.forEach(function (cb) {
          var parts = cb.value.split('-');
          var pMin = parseInt(parts[0]);
          var pMax = parseInt(parts[1]);
          /* チェックボックスの範囲が完全にスライダー範囲内ならチェック */
          cb.checked = pMin >= lo && pMax <= hi;
        });
      }

      function syncFromSliders() {
        var lo = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
        var hi = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
        minInput.value = lo;
        maxInput.value = hi;
        updateFill();
        updateHiddenInputs();
        syncPresetsFromSliders();
      }

      minThumb.addEventListener('input', syncFromSliders);
      maxThumb.addEventListener('input', syncFromSliders);

      minInput.addEventListener('change', function () {
        var v = parseInt(minInput.value) || rangeMin;
        minThumb.value = v;
        syncFromSliders();
      });
      maxInput.addEventListener('change', function () {
        var v = parseInt(maxInput.value) || rangeMax;
        maxThumb.value = v;
        syncFromSliders();
      });

      /* チェックボックス → スライダー連動 */
      presetCheckboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {
          var checked = body.querySelectorAll('[data-edition-preset]:checked');
          if (checked.length === 0) {
            /* 全解除時はスライダーを全範囲に戻す */
            minThumb.value = rangeMin;
            maxThumb.value = rangeMax;
          } else {
            /* チェック済み範囲の min/max をマージ */
            var lo = Infinity,
              hi = 0;
            checked.forEach(function (c) {
              var parts = c.value.split('-');
              var pMin = parseInt(parts[0]);
              var pMax = parseInt(parts[1]);
              if (pMin < lo) lo = pMin;
              if (pMax > hi) hi = pMax;
            });
            minThumb.value = lo;
            maxThumb.value = hi;
          }
          var lo2 = Math.min(parseInt(minThumb.value), parseInt(maxThumb.value));
          var hi2 = Math.max(parseInt(minThumb.value), parseInt(maxThumb.value));
          minInput.value = lo2;
          maxInput.value = hi2;
          updateFill();
          updateHiddenInputs();
        });
      });

      updateFill();
    });

    /* --- キーワード検索（Enter で /search に遷移） --- */
    document.querySelectorAll('[data-sidebar-search-input]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var q = input.value.trim() || '*';
        if (window.location.pathname === '/search') {
          var url = new URL(window.location.href);
          url.searchParams.set('q', q);
          url.searchParams.set('type', 'product');
          url.searchParams.delete('page');
          window.location.href = url.toString();
        } else {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      });
    });
  })();

  /* --- オークション残り時間の表示 --- */
  (function () {
    function formatRemaining(ms) {
      if (ms <= 0) return '終了';
      var totalSeconds = Math.floor(ms / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      if (days > 0) return days + '日' + hours + '時間';
      if (hours > 0) return hours + '時間' + minutes + '分';
      return minutes + '分';
    }

    function updateRemainingTimes() {
      var elements = document.querySelectorAll('.p-index .c-label-time[data-ends-at]');
      var now = Date.now();
      elements.forEach(function (el) {
        var endsAt = new Date(el.dataset.endsAt).getTime();
        var remaining = endsAt - now;
        var span = el.querySelector('.js-remaining-time');
        if (span) {
          span.textContent = formatRemaining(remaining);
        }
      });
    }

    updateRemainingTimes();
    setInterval(updateRemainingTimes, 60000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-page"] && !Shopify.designMode) return;
  try {
    
  /* FAQ ページ: アコーディオンの開閉制御 */
  (function () {
    var panels = document.querySelectorAll('.p-faq-page .c-collapsible-panel');
    panels.forEach(function (panel) {
      var details = panel;
      var summary = panel.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          panel.classList.remove('is-open');
          setTimeout(function () {
            details.removeAttribute('open');
          }, 600);
        } else {
          details.setAttribute('open', '');
          requestAnimationFrame(function () {
            panel.classList.add('is-open');
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  /* FAQ: アコーディオンの開閉制御 */
  (function () {
    var panels = document.querySelectorAll('.p-top-faq .c-collapsible-panel');
    panels.forEach(function (panel) {
      var details = panel;
      var summary = panel.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          panel.classList.remove('is-open');
          setTimeout(function () {
            details.removeAttribute('open');
          }, 600);
        } else {
          details.setAttribute('open', '');
          requestAnimationFrame(function () {
            panel.classList.add('is-open');
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-artists"] && !Shopify.designMode) return;
  try {
    
  /* アーティスト一覧: ドラッグスクロールカルーセル */
  (function () {
    var viewports = document.querySelectorAll('[data-featured-viewport]');
    viewports.forEach(function (viewport) {
      var track = viewport.querySelector('[data-featured-track]');
      if (!track) return;

      var offset = 0;
      var maxOffset = 0;
      var dragging = false;
      var moved = false;
      var startX = 0;
      var startOffset = 0;

      function measure() {
        /* viewport の padding（左ガター等）分だけ表示領域が狭くなるため、
           clientWidth はパディングを含む。末尾まで到達できるよう padding を加算する */
        var cs = window.getComputedStyle(viewport);
        var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth + padX);
        offset = Math.min(Math.max(offset, 0), maxOffset);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function pointX(e) {
        return e.touches ? e.touches[0].clientX : e.clientX;
      }

      function onStart(e) {
        measure();
        dragging = true;
        moved = false;
        startX = pointX(e);
        startOffset = offset;
        track.style.transition = 'none';
        viewport.classList.add('is-dragging');
      }

      function onMove(e) {
        if (!dragging) return;
        var dx = pointX(e) - startX;
        if (Math.abs(dx) > 4 && !moved) {
          moved = true;
          /* 実際にドラッグを開始したときのみポインタをキャプチャする。
             pointerdown 時点でキャプチャすると click がビューポートへ再ターゲットされ、
             リンク（<a>）の遷移が発生しなくなるため、ドラッグ確定後に限定する。 */
          if (e.pointerId !== undefined && viewport.setPointerCapture) {
            try {
              viewport.setPointerCapture(e.pointerId);
            } catch (err) {}
          }
        }
        offset = Math.min(Math.max(startOffset - dx, 0), maxOffset);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function onEnd() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        viewport.classList.remove('is-dragging');
      }

      viewport.addEventListener('pointerdown', onStart);
      viewport.addEventListener('pointermove', onMove);
      viewport.addEventListener('pointerup', onEnd);
      viewport.addEventListener('pointercancel', onEnd);
      viewport.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      viewport.addEventListener(
        'click',
        function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      window.addEventListener('resize', measure);
      measure();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-artworks"] && !Shopify.designMode) return;
  try {
    
  /* 注目の作品: オークション残り時間の計算と表示 */
  (function () {
    function formatRemaining(ms) {
      if (ms <= 0) return '終了';
      var totalSeconds = Math.floor(ms / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      if (days > 0) return days + '日' + hours + '時間';
      if (hours > 0) return hours + '時間' + minutes + '分';
      return minutes + '分';
    }

    function updateRemainingTimes() {
      var elements = document.querySelectorAll('.p-top-artworks .c-label-time[data-ends-at]');
      var now = Date.now();
      elements.forEach(function (el) {
        var endsAt = new Date(el.dataset.endsAt).getTime();
        var remaining = endsAt - now;
        var span = el.querySelector('.js-remaining-time');
        if (span) {
          span.textContent = formatRemaining(remaining);
        }
      });
    }

    updateRemainingTimes();
    setInterval(updateRemainingTimes, 60000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.getElementById('custom-header');
    var menu = document.getElementById('custom-menu');
    var trigger = document.getElementById('custom-trigger');
    var compact = document.getElementById('custom-header-compact');
    if (!header || !menu || !trigger || !compact) return;

    var wrapper = header.querySelector('.c-header__wrapper');
    var main = document.getElementById('MainContent') || document.getElementById('main') || null;
    var footer = document.querySelector('footer') || null;
    var focusableSelector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';
    var mq = window.matchMedia('(width < 800px)');
    var savedScrollY = 0;

    /* KV 反転 */
    var reverseTargets = document.querySelectorAll('[data-header-reverse]');
    if (reverseTargets.length > 0) {
      reverseTargets.forEach(function (el) {
        var wh = wrapper ? wrapper.clientHeight : 72;
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                header.classList.add('is-reverse');
              } else {
                header.classList.remove('is-reverse');
              }
            });
          },
          {
            rootMargin: '-' + wh / 2 + 'px 0px ' + (100 - (wh / 2 / window.innerHeight) * 100) + '% 0px',
          }
        ).observe(el);
      });
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        closeMenu();
        return;
      }
      if (e.key === 'Tab') {
        var els = menu.querySelectorAll(focusableSelector);
        if (!els.length) return;
        if (e.shiftKey && document.activeElement === els[0]) {
          e.preventDefault();
          els[els.length - 1].focus();
        }
        if (!e.shiftKey && document.activeElement === els[els.length - 1]) {
          e.preventDefault();
          els[0].focus();
        }
      }
    }

    function openMenu() {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-label', 'メニューを閉じる');
      menu.setAttribute('aria-hidden', 'false');
      menu.removeAttribute('inert');
      if (main) main.setAttribute('inert', '');
      if (footer) footer.setAttribute('inert', '');
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.width = '100%';
      document.addEventListener('keydown', onKeyDown);
      document.documentElement.classList.add('dialog-open');
      var first = menu.querySelectorAll(focusableSelector)[0];
      if (first) first.focus({ focusVisible: true });
    }

    function closeMenu() {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', 'メニューを開く');
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('inert', '');
      if (main) main.removeAttribute('inert');
      if (footer) footer.removeAttribute('inert');
      document.body.removeAttribute('style');
      window.scrollTo(0, savedScrollY);
      document.removeEventListener('keydown', onKeyDown);
      document.documentElement.classList.remove('dialog-open');
    }

    function toggleMenu() {
      trigger.getAttribute('aria-expanded') === 'true' ? closeMenu() : openMenu();
    }

    function onBackdropClick(e) {
      if (e.target === menu) closeMenu();
    }

    function onScroll() {
      compact.setAttribute('aria-hidden', window.scrollY > 310 ? 'false' : 'true');
    }

    function onMediaChange(e) {
      closeMenu();
      if (e.matches) {
        menu.setAttribute('inert', '');
        menu.querySelector('.c-header__menu-inner').setAttribute('role', 'dialog');
        trigger.addEventListener('click', toggleMenu);
        menu.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', closeMenu);
        });
        document.addEventListener('click', onBackdropClick);
        window.removeEventListener('scroll', onScroll);
      } else {
        trigger.removeEventListener('click', toggleMenu);
        menu.querySelectorAll('a').forEach(function (a) {
          a.removeEventListener('click', closeMenu);
        });
        menu.setAttribute('aria-hidden', 'false');
        menu.removeAttribute('inert');
        menu.querySelector('.c-header__menu-inner').removeAttribute('role');
        window.addEventListener('scroll', onScroll, { passive: true });
        document.removeEventListener('click', onBackdropClick);
        onScroll();
      }
    }

    onMediaChange(mq);
    mq.addEventListener('change', onMediaChange);

    /* カート数のリアルタイム更新 */
    var countEls = [header.querySelector('.c-header__count'), compact.querySelector('.c-header-compact__count')].filter(
      Boolean
    );

    function getCurrentCount() {
      var el = countEls[0];
      return el ? parseInt(el.textContent, 10) || 0 : 0;
    }

    function updateCartCount(newCount) {
      countEls.forEach(function (el) {
        el.textContent = newCount;
      });
    }

    document.addEventListener('cart:update', function (e) {
      var detail = e.detail || {};
      var data = detail.data || {};
      var itemCount = data.itemCount || 0;
      var fromProductForm = data.source === 'product-form-component';

      if (fromProductForm) {
        /* product-form からの場合、itemCount は追加数なので加算 */
        updateCartCount(getCurrentCount() + itemCount);
      } else {
        /* それ以外は合計値 */
        updateCartCount(itemCount);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-kv"] && !Shopify.designMode) return;
  try {
    
  /* KV セクション: data 属性から CSS カスタムプロパティへの変換、IntersectionObserver による一時停止制御 */
  (function () {
    var kvEl = document.querySelector('.p-top-kv');
    if (!kvEl) return;

    var imagesEl = kvEl.querySelector('.p-top-kv > .images');
    if (!imagesEl) return;

    var keys = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];
    keys.forEach(function (key) {
      var attrName = 'background' + key.charAt(0).toUpperCase() + key.slice(1);
      var url = imagesEl.dataset[attrName];
      if (url) {
        imagesEl.style.setProperty('--background-' + key, 'url("' + url + '")');
      }
    });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          kvEl.classList.remove('is-paused');
        } else {
          kvEl.classList.add('is-paused');
        }
      });
    }).observe(kvEl);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-new-artworks"] && !Shopify.designMode) return;
  try {
    
  /* 新着作品: Embla Carousel の CDN 読み込みと初期化 */
  (function () {
    var EMBLA_CDN = "https://unpkg.com/embla-carousel@8.5.2/embla-carousel.umd.js";

    function initCarousel() {
      var sections = document.querySelectorAll(".p-top-new .c-embla");
      if (!sections.length) return;

      sections.forEach(function (root) {
        var viewport = root.querySelector(".c-embla__viewport");
        var prevBtn = root.querySelector(".c-embla__button--prev");
        var nextBtn = root.querySelector(".c-embla__button--next");
        if (!viewport) return;

        var embla = EmblaCarousel(viewport, {
          align: "start",
          axis: "x",
          slidesToScroll: 1,
          loop: false,
          duration: 25,
          draggable: true,
          breakpoints: {
            "(width >= 800px)": {},
          },
        });

        function updateButtons() {
          if (!prevBtn || !nextBtn) return;
          if (embla.canScrollPrev()) {
            prevBtn.classList.remove("c-embla__button--disabled");
          } else {
            prevBtn.classList.add("c-embla__button--disabled");
          }
          if (embla.canScrollNext()) {
            nextBtn.classList.remove("c-embla__button--disabled");
          } else {
            nextBtn.classList.add("c-embla__button--disabled");
          }
        }

        updateButtons();
        embla.on("select", updateButtons).on("reInit", updateButtons);

        if (prevBtn) {
          prevBtn.addEventListener("click", function () {
            embla.scrollPrev();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener("click", function () {
            embla.scrollNext();
          });
        }
      });
    }

    if (typeof EmblaCarousel !== "undefined") {
      initCarousel();
      return;
    }

    var script = document.createElement("script");
    script.src = EMBLA_CDN;
    script.onload = initCarousel;
    document.head.appendChild(script);
  })();

  /* 新着作品: オークション残り時間の計算と表示 */
  (function () {
    function formatRemaining(ms) {
      if (ms <= 0) return "終了";
      var totalSeconds = Math.floor(ms / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      if (days > 0) return days + "日" + hours + "時間";
      if (hours > 0) return hours + "時間" + minutes + "分";
      return minutes + "分";
    }

    function updateRemainingTimes() {
      var elements = document.querySelectorAll(".p-top-new .c-label-time[data-ends-at]");
      var now = Date.now();
      elements.forEach(function (el) {
        var endsAt = new Date(el.dataset.endsAt).getTime();
        var remaining = endsAt - now;
        var span = el.querySelector(".js-remaining-time");
        if (span) {
          span.textContent = formatRemaining(remaining);
        }
      });
    }

    updateRemainingTimes();
    setInterval(updateRemainingTimes, 60000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-detail-auction"] && !Shopify.designMode) return;
  try {
    
  /* 商品詳細: アコーディオンの開閉制御
     <details> の native toggle を使わず、open を常時付与し
     is-open クラスだけで表示を制御する。
     これにより dialog.js / component.js の toggle イベント監視との競合を回避する。 */
  (function () {
    var panels = document.querySelectorAll('.p-product .c-collapsible-panel');
    panels.forEach(function (panel) {
      var summary = panel.querySelector('summary');
      if (!summary) return;

      /* open 属性を常時付与（コンテンツを DOM に保持） */
      panel.setAttribute('open', '');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        panel.classList.toggle('is-open');
      });
    });
  })();

  /* 商品詳細: サムネイルクリックで画像切り替え + アクティブ切り替え */
  (function () {
    var gallery = document.querySelector('.p-product-gallery');
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll('.thumbnails .thumb');
    var slides = gallery.querySelectorAll('.slide');
    var viewport = gallery.querySelector('.viewport');
    var isPC = function () {
      return window.matchMedia('(min-width: 800px)').matches;
    };

    /* 初期状態: 最初のスライドをアクティブに */
    if (slides[0]) slides[0].classList.add('is-active');
    if (thumbs[0]) thumbs[0].classList.add('is-active');

    /* サムネイルクリック */
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var slide = slides[index];
        if (!slide) return;

        if (isPC()) {
          /* PC: アクティブスライドを切り替え */
          slides.forEach(function (s) {
            s.classList.remove('is-active');
          });
          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          slide.classList.add('is-active');
          thumb.classList.add('is-active');
        } else if (viewport) {
          /* モバイル: viewport 内を横スクロール */
          viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    /* モバイル: マウスドラッグでスクロール */
    if (viewport) {
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;

      viewport.addEventListener('mousedown', function (e) {
        if (isPC()) return;
        isDragging = true;
        startX = e.pageX;
        scrollStart = viewport.scrollLeft;
        viewport.style.cursor = 'grabbing';
        viewport.style.scrollSnapType = 'none';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var dx = e.pageX - startX;
        viewport.scrollLeft = scrollStart - dx;
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        viewport.style.cursor = '';
        viewport.style.scrollSnapType = '';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-detail"] && !Shopify.designMode) return;
  try {
    
  /* 商品詳細: バンドル商品のバリエーント連動 */
  (function () {
    var variantsEl = document.querySelector('.p-product-variants');
    if (!variantsEl) return;

    var bundleHandle = variantsEl.dataset.bundleHandle;
    var sectionId = variantsEl.dataset.sectionId;
    if (!bundleHandle) return;

    /* オプションインデックス（A商品のoption1/option2/option3との対応） */
    var sizeIdx = variantsEl.dataset.sizeIndex !== '' ? parseInt(variantsEl.dataset.sizeIndex, 10) : null;
    var frameIdx = variantsEl.dataset.frameIndex !== '' ? parseInt(variantsEl.dataset.frameIndex, 10) : null;
    var acrylicIdx = variantsEl.dataset.acrylicIndex !== '' ? parseInt(variantsEl.dataset.acrylicIndex, 10) : null;

    var bundleVariants = null;
    var variantIdInput = document.querySelector('#product-' + sectionId + ' input[name="id"][ref="variantId"]');
    if (!variantIdInput) return;
    var variantImageInput = document.querySelector('#product-' + sectionId + ' input[ref="variantImage"]');

    /* バンドル商品のオプションインデックス */
    var bundleSizeIdx = null;
    var bundleFrameIdx = null;
    var bundleAcrylicIdx = null;

    /* バンドル商品のデータを取得 */
    fetch('/products/' + bundleHandle + '.js')
      .then(function (res) {
        if (!res.ok) {
          throw new Error('バンドル商品が見つかりません');
        }
        return res.json();
      })
      .then(function (data) {
        bundleVariants = data.variants;
        /* バンドル商品のオプション名からインデックスを特定（末尾の括弧内キーワードで判定） */
        (data.options || []).forEach(function (opt, idx) {
          var name = typeof opt === 'string' ? opt : (opt.name || '');
          if (name === 'サイズ') bundleSizeIdx = idx;
          else if (name === '額縁') bundleFrameIdx = idx;
          else if (name === 'アクリル') bundleAcrylicIdx = idx;
          else if (/\(額縁\)\s*$/.test(name)) bundleFrameIdx = idx;
          else if (/\(アクリル\)\s*$/.test(name)) bundleAcrylicIdx = idx;
          else if (/\(サイズ\)\s*$/.test(name)) bundleSizeIdx = idx;
        });
        updateVariantId();
      })
      .catch(function (err) {
        /* バンドル商品が存在しない場合はカート・今すぐ購入ボタンを無効化してエラー表示 */
        if (addToCartButton) addToCartButton.disabled = true;
        if (buyNowButton) buyNowButton.setAttribute('aria-disabled', 'true');
        variantIdInput.value = '';
        var errorEl = document.querySelector('#product-' + sectionId + ' [ref="addToCartTextError"]');
        if (errorEl) {
          errorEl.textContent = 'この商品は現在購入できません';
          errorEl.classList.remove('hidden');
        }
      });

    /* 選択中のオプション値を取得 */
    function getSelectedOptions() {
      var sizeInput = variantsEl.querySelector('input[name="size"]:checked');
      var frameInput = variantsEl.querySelector('input[name="frame"]:checked');
      var acrylicInput = variantsEl.querySelector('input[name="acrylic"]:checked');
      return {
        size: sizeInput ? sizeInput.value : null,
        frame: frameInput ? frameInput.value : null,
        acrylic: acrylicInput ? acrylicInput.value : null,
      };
    }

    var priceEl = document.querySelector('#product-' + sectionId + ' [data-bundle-price]');

    /* A商品のバリエーションデータを取得 */
    var productVariantsEl = document.querySelector('#product-' + sectionId + ' [data-product-variants]');
    var productVariants = productVariantsEl ? JSON.parse(productVariantsEl.textContent) : [];

    /* 価格をフォーマット */
    function formatPrice(cents) {
      return Math.floor(cents / 100).toLocaleString('ja-JP');
    }

    /* Liquid money_without_currency の出力と比較して補正を検出 */
    (function () {
      if (!priceEl || productVariants.length === 0) return;
      var initialText = priceEl.textContent.replace(/[,\s]/g, '');
      var initialPrice = parseInt(initialText, 10);
      if (initialPrice === productVariants[0].price) {
        formatPrice = function (price) {
          return price.toLocaleString('ja-JP');
        };
      }
    })();

    /* 選択値の表示要素 */
    var sizeOutputEl = document.querySelector('#product-' + sectionId + ' [data-size-output]');
    /* 作品情報テーブルのサイズ表示（選択サイズに追従） */
    var sizeSpecEl = document.querySelector('#product-' + sectionId + ' [data-size-spec]');
    /* 選択サイズ→復元画サイズ表示文字列（例: "200 x 400 mm"）のマップ */
    var reproSizeMap = {};
    if (sizeSpecEl && sizeSpecEl.dataset.reproSizes) {
      try {
        reproSizeMap = JSON.parse(sizeSpecEl.dataset.reproSizes);
      } catch (e) {}
    }
    var frameOutputEl = document.querySelector('#product-' + sectionId + ' [data-frame-output]');
    var acrylicOutputEl = document.querySelector('#product-' + sectionId + ' [data-acrylic-output]');

    /* ギャラリー要素 */
    var gallery = document.querySelector('#product-' + sectionId + ' .p-product-gallery');

    /* 額縁グループ要素 */
    var frameGroup = variantsEl.querySelector('[data-frame-group]');

    /* アクリルグループ要素 */
    var acrylicGroup = variantsEl.querySelector('[data-acrylic-group]');

    /* カートボタン */
    var addToCartButton = document.querySelector('#product-' + sectionId + ' button[name="add"]');

    /* 今すぐ購入ボタン（カートボタンと同様に未選択時は非活性にする） */
    var buyNowButton = document.querySelector('#product-' + sectionId + ' [data-buy-now]');
    /* カート追加処理の本体（product-form.js）。今すぐ購入時は遷移先を上書きするために参照する */
    var productForm = document.querySelector('#product-' + sectionId + ' product-form-component');
    if (buyNowButton && addToCartButton && productForm) {

      /* 二重送信防止＆失敗時に遷移先の上書きを解除するためのフラグ */
      var buyNowPending = false;

      /* クリック時: 「カートに追加」と同一の処理を実行し、遷移先だけチェックアウトに切り替える
         （ローディング表示はカート追加ローディング側で両ボタン共通に制御する） */

      buyNowButton.addEventListener('click', function (e) {
        e.preventDefault();
        /* 非活性（バリエーション未選択など）のときは何もしない */
        if (buyNowButton.getAttribute('aria-disabled') === 'true') return;
        /* 二重送信防止 */
        if (buyNowPending) return;

        buyNowPending = true;
        /* カート追加成功後の遷移先をチェックアウトに上書き（product-form.js が参照） */
        productForm.dataset.redirectTo = '/checkout';
        /* カート追加ボタンと同じ処理（AJAX追加・バリデーション・_variant_image 等）を実行 */
        addToCartButton.click();
      });

      /* カート追加に失敗したら遷移先の上書きを解除し、ボタンを再度押せる状態に戻す */
      document.addEventListener('cart:error', function () {
        if (!buyNowPending) return;
        buyNowPending = false;

        delete productForm.dataset.redirectTo;
      });
    }

    /* A商品のバリエーションからオプションインデックスで検索するヘルパー */
    function findVariant(variants, size, frame, acrylic) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        var sizeMatch = sizeIdx !== null ? opts[sizeIdx] === size : true;
        var frameMatch = frameIdx !== null ? opts[frameIdx] === frame : true;
        var acrylicMatch = acrylicIdx !== null ? opts[acrylicIdx] === acrylic : true;
        return sizeMatch && frameMatch && acrylicMatch;
      });
    }

    /* バンドル商品のバリエーション検索（バンドル独自のインデックスで検索、なければスキップ） */
    function findBundleVariant(variants, size, frame, acrylic) {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        var sizeMatch = bundleSizeIdx !== null ? opts[bundleSizeIdx] === size : true;
        var frameMatch = bundleFrameIdx !== null ? opts[bundleFrameIdx] === frame : true;
        var acrylicMatch = bundleAcrylicIdx !== null ? opts[bundleAcrylicIdx] === acrylic : true;
        return sizeMatch && frameMatch && acrylicMatch;
      });
    }

    /* 指定サイズの最安バリエーションを返す（「なし」が存在しない場合のフォールバック用） */
    function findCheapestForSize(variants, size) {
      var cheapest = null;
      variants.forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        if (sizeIdx !== null && opts[sizeIdx] !== size) return;
        if (!cheapest || v.price < cheapest.price) cheapest = v;
      });
      return cheapest;
    }

    /* 額縁価格の表示を更新（選択サイズの「なし」との差額、アクリルは固定「なし」で計算） */
    function updateFramePrices(selectedSize) {
      var baseVariant = findVariant(productVariants, selectedSize, 'なし', 'なし');
      if (!baseVariant) baseVariant = findCheapestForSize(productVariants, selectedSize);
      var basePrice = baseVariant ? baseVariant.price : 0;

      var framePriceEls = variantsEl.querySelectorAll('[data-frame-price]');
      framePriceEls.forEach(function (el) {
        var frameName = el.getAttribute('data-frame-price');
        var frameVariant = findVariant(productVariants, selectedSize, frameName, 'なし');
        if (!frameVariant) return;

        var diff = frameVariant.price - basePrice;
        el.textContent = '+ ¥' + formatPrice(diff);
      });
    }

    /* 額縁サムネイル画像をサイズに応じて更新し、画像有無で表示型を切り替え */
    function updateFrameImages(selectedSize) {
      var frameThumbEls = variantsEl.querySelectorAll('[data-frame-thumb]');
      frameThumbEls.forEach(function (thumb) {
        var frameName = thumb.getAttribute('data-frame-thumb');
        var frameVariant = findVariant(productVariants, selectedSize, frameName, 'なし');
        var img = thumb.querySelector('img');
        var label = thumb.closest('.frame-button');
        /* 選択サイズのバリアントに画像が登録されているか */
        var hasImage = !!(frameVariant && frameVariant.featured_image);

        if (img) {
          if (hasImage) {
            /* Shopify の image_url 相当: CDNパスから幅指定URLを生成 */
            var src = frameVariant.featured_image.src;
            /* _WIDTHx を置換して120px幅のURLを作成 */
            img.src = src.replace(/(\.[^.]+)$/, '_120x$1');
            img.style.display = '';
          } else {
            img.style.display = 'none';
          }
        }

        /* 画像あり: 画像型(c-input-image) / 画像なし: テキスト型(c-input-button) に切替 */
        if (label) {
          label.classList.toggle('c-input-image', hasImage);
          label.classList.toggle('c-input-button', !hasImage);
        }
      });
    }

    /* アクリル価格の表示を更新（選択サイズ＋額縁のアクリル「なし」との差額） */
    function updateAcrylicPrices(selectedSize, selectedFrame) {
      var baseVariant = findVariant(productVariants, selectedSize, selectedFrame, 'なし');
      if (!baseVariant) baseVariant = findVariant(productVariants, selectedSize, selectedFrame, null) || findCheapestForSize(productVariants, selectedSize);
      var basePrice = baseVariant ? baseVariant.price : 0;

      var acrylicPriceEls = variantsEl.querySelectorAll('[data-acrylic-price]');
      acrylicPriceEls.forEach(function (el) {
        var acrylicName = el.getAttribute('data-acrylic-price');
        var acrylicVariant = findVariant(productVariants, selectedSize, selectedFrame, acrylicName);
        if (!acrylicVariant) return;

        var diff = acrylicVariant.price - basePrice;
        el.textContent = '+ ¥' + formatPrice(diff);
      });
    }

    /* バリエーション選択に応じてメイン画像を切り替え */
    function switchToVariantImage(selected) {
      if (!gallery || !selected.size) return;

      var frame = selected.frame || 'なし';
      var acrylic = selected.acrylic || 'なし';
      var match = findVariant(productVariants, selected.size, frame, acrylic);
      if (!match || !match.featured_image) return;

      /* featured_image.position は1始まりの画像位置 */
      var position = match.featured_image.position;
      var slides = gallery.querySelectorAll('.slide');
      var thumbs = gallery.querySelectorAll('.thumbnails .thumb');
      var isPC = window.matchMedia('(min-width: 800px)').matches;

      slides.forEach(function (s) {
        s.classList.remove('is-active');
      });
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });

      var targetSlide = slides[position - 1];
      var targetThumb = thumbs[position - 1];

      if (targetSlide) targetSlide.classList.add('is-active');
      if (targetThumb) targetThumb.classList.add('is-active');

      /* モバイル: 該当スライドへスクロール */
      if (!isPC && targetSlide) {
        var viewport = gallery.querySelector('.viewport');
        if (viewport) {
          viewport.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
        }
      }
    }

    /* 選択サイズに存在する額縁のみ表示し、存在しない額縁を非表示にする */
    function updateFrameVisibility(selectedSize) {
      if (!frameGroup) return;

      /* サイズ未選択時は額縁グループ全体を非表示 */
      if (!selectedSize) {
        frameGroup.style.display = 'none';
        return;
      }

      frameGroup.style.display = '';

      /* 選択サイズに存在する額縁値を収集 */
      var availableFrames = {};
      productVariants.forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        if (sizeIdx !== null && opts[sizeIdx] === selectedSize && frameIdx !== null) {
          availableFrames[opts[frameIdx]] = true;
        }
      });

      /* 各額縁ボタンの表示/非表示を切り替え */
      var frameItems = frameGroup.querySelectorAll('[data-frame-value]');
      frameItems.forEach(function (item) {
        var frameValue = item.getAttribute('data-frame-value');
        item.style.display = availableFrames[frameValue] ? '' : 'none';
      });

      /* 選択中の額縁が非表示になった場合は選択解除 */
      var checkedFrame = variantsEl.querySelector('input[name="frame"]:checked');
      if (checkedFrame && !availableFrames[checkedFrame.value]) {
        checkedFrame.checked = false;
      }
    }

    /* アクリルグループの表示/非表示を制御 */
    function updateAcrylicVisibility(selectedFrame) {
      if (!acrylicGroup) return;

      var wasHidden = acrylicGroup.style.display === 'none';
      var selected = getSelectedOptions();

      if (selectedFrame && selectedFrame !== 'なし') {
        /* 額縁あり → アクリル選択を表示 */
        acrylicGroup.style.display = '';
        if (wasHidden) {
          /* 非表示→表示の遷移時、アクリル選択をリセット */
          variantsEl.querySelectorAll('input[name="acrylic"]').forEach(function (r) {
            r.checked = false;
          });
        }

        /* 選択サイズ+額縁に存在するアクリル値のみ表示 */
        if (selected.size && acrylicIdx !== null) {
          var availableAcrylics = {};
          productVariants.forEach(function (v) {
            var opts = [v.option1, v.option2, v.option3];
            var sizeMatch = sizeIdx !== null ? opts[sizeIdx] === selected.size : true;
            var frameMatch = frameIdx !== null ? opts[frameIdx] === selectedFrame : true;
            if (sizeMatch && frameMatch) {
              availableAcrylics[opts[acrylicIdx]] = true;
            }
          });

          var acrylicItems = acrylicGroup.querySelectorAll('.item');
          acrylicItems.forEach(function (item) {
            var input = item.querySelector('input[name="acrylic"]');
            if (!input) return;
            item.style.display = availableAcrylics[input.value] ? '' : 'none';
          });

          /* 選択中のアクリルが非表示になった場合は選択解除 */
          var checkedAcrylic = variantsEl.querySelector('input[name="acrylic"]:checked');
          if (checkedAcrylic && !availableAcrylics[checkedAcrylic.value]) {
            checkedAcrylic.checked = false;
          }
        }
      } else {
        /* 額縁なし or 未選択 → アクリル選択を非表示、「なし」を自動選択 */
        acrylicGroup.style.display = 'none';
        var acrylicNone = variantsEl.querySelector('input[name="acrylic"][value="なし"]');
        if (acrylicNone) acrylicNone.checked = true;
        variantsEl.querySelectorAll('input[name="acrylic"]:not([value="なし"])').forEach(function (r) {
          r.checked = false;
        });
      }
    }

    /* カートボタンの有効/無効を制御 */
    function updateCartButton() {
      if (!addToCartButton) return;
      var selected = getSelectedOptions();
      var allSelected = false;

      if (selected.size && selected.frame) {
        if (!acrylicGroup) {
          /* アクリルオプションがない商品 */
          allSelected = true;
        } else if (selected.frame === 'なし') {
          /* 額縁なし → アクリル不要（自動で「なし」選択済み） */
          allSelected = true;
        } else {
          /* 額縁あり → アクリルも選択が必要 */
          allSelected = !!selected.acrylic;
        }
      }

      /* バンドル商品のバリエーションIDが未設定なら無効 */
      if (allSelected && variantIdInput && !variantIdInput.value) {
        allSelected = false;
      }

      addToCartButton.disabled = !allSelected;

      /* 今すぐ購入ボタンもカートボタンと同じ活性状態に揃える */
      if (buyNowButton) {
        buyNowButton.setAttribute('aria-disabled', String(!allSelected));
      }
    }

    /* 選択に対応するバンドルバリエーントIDをフォームに設定し、A商品の価格を表示 */
    function updateVariantId() {
      var selected = getSelectedOptions();

      /* 選択値の表示を更新 */
      if (sizeOutputEl) sizeOutputEl.textContent = selected.size || '';
      /* 作品情報テーブルのサイズ: 未選択時は「- x - mm」、選択時は復元画サイズ（例: 200 x 400 mm） */
      if (sizeSpecEl) {
        sizeSpecEl.textContent =
          selected.size && reproSizeMap[selected.size] ? reproSizeMap[selected.size] : '- x - mm';
      }
      if (frameOutputEl) frameOutputEl.textContent = selected.frame || '';
      if (acrylicOutputEl) acrylicOutputEl.textContent = selected.acrylic || '';

      /* 額縁グループの表示制御（サイズに応じて利用可能な額縁のみ表示） */
      updateFrameVisibility(selected.size);

      /* アクリルグループの表示制御 */
      updateAcrylicVisibility(selected.frame);

      /* アクリルの自動リセット後の選択状態を再取得 */
      selected = getSelectedOptions();

      /* カートボタンの有効/無効 */
      updateCartButton();

      /* バリエーション画像に切り替え */
      switchToVariantImage(selected);

      if (!selected.size) return;

      /* 額縁のサムネイル画像・差額表示を更新 */
      updateFrameImages(selected.size);
      updateFramePrices(selected.size);

      /* アクリルの差額表示を事前計算（額縁未選択時は最安の額縁を基準にする） */
      if (acrylicGroup) {
        var frameForAcrylic = selected.frame;
        if (!frameForAcrylic || frameForAcrylic === 'なし') {
          /* 最安の額縁を探す */
          var cheapest = findCheapestForSize(productVariants, selected.size);
          if (cheapest && frameIdx !== null) {
            frameForAcrylic = [cheapest.option1, cheapest.option2, cheapest.option3][frameIdx];
          }
        }
        if (frameForAcrylic && frameForAcrylic !== 'なし') {
          updateAcrylicPrices(selected.size, frameForAcrylic);
        }
      }

      /* 額縁オプションがある場合、未選択なら以降の処理をスキップ */
      if (frameIdx !== null && !selected.frame) return;

      /* A商品のバリアント価格・画像URLを更新 */
      var effectiveFrame = selected.frame || 'なし';
      var effectiveAcrylic = selected.acrylic || 'なし';
      var variantMatch = findVariant(productVariants, selected.size, effectiveFrame, effectiveAcrylic);
      if (variantMatch) {
        if (priceEl) {
          priceEl.textContent = formatPrice(variantMatch.price);
        }
        /* カート表示用にA商品のバリアント画像URLを設定（なければメイン画像） */
        if (variantImageInput) {
          variantImageInput.value = variantMatch.featured_image
            ? variantMatch.featured_image.src
            : variantsEl.dataset.featuredImage || '';
        }
      }

      /* バンドルのバリエーションからカート用IDを設定 */
      if (!bundleVariants) return;

      var bundleMatch = findBundleVariant(bundleVariants, selected.size, effectiveFrame, effectiveAcrylic);
      if (bundleMatch) {
        variantIdInput.value = bundleMatch.id;
      } else {
        /* マッチしない場合はカートに追加できないようにする */
        variantIdInput.value = '';
      }
      /* カートボタンの有効/無効はupdateCartButtonで一元管理 */
      updateCartButton();
    }

    /* ラジオボタンの変更を監視 */
    variantsEl.addEventListener('change', function (e) {
      if (e.target.name === 'size' || e.target.name === 'frame' || e.target.name === 'acrylic') {
        updateVariantId();
      }
    });

    /* 初期状態: カートボタンを無効化 */
    updateCartButton();
  })();

  /* 商品詳細: カート追加ローディングアニメーション
     「カートに追加」と「今すぐ購入」は同じカート追加処理を共有するため、
     どちらを押しても両方のボタンをローディング表示にする。 */
  (function () {
    var cta = document.querySelector('.p-product-detail .cta');
    if (!cta) return;

    var addButton = cta.querySelector('button[name="add"]');
    if (!addButton) return;

    /* 今すぐ購入ボタン（存在すれば一緒にローディングさせる） */
    var buyNowButton = cta.querySelector('[data-buy-now]');

    /* 既存の即時チェックマークアニメーションを無効化 */
    addButton.dataset.puppet = 'true';

    var isSubmitting = false;

    function startLoading() {
      if (addButton.disabled || isSubmitting) return;
      isSubmitting = true;
      addButton.classList.add('is-loading');
      if (buyNowButton) buyNowButton.classList.add('is-loading');
    }

    function stopLoading() {
      if (!isSubmitting) return;
      isSubmitting = false;
      addButton.classList.remove('is-loading');
      if (buyNowButton) buyNowButton.classList.remove('is-loading');
    }

    addButton.addEventListener('click', startLoading);
    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        /* 非活性（バリエーション未選択）のときはローディングしない */
        if (buyNowButton.getAttribute('aria-disabled') === 'true') return;
        startLoading();
      });
    }

    document.addEventListener('cart:update', stopLoading);
    document.addEventListener('cart:error', stopLoading);
  })();

  /* 商品詳細: アコーディオンの開閉制御
     <details> の native toggle を使わず、open を常時付与し
     is-open クラスだけで表示を制御する。
     これにより dialog.js / component.js の toggle イベント監視との競合を回避する。 */
  (function () {
    var panels = document.querySelectorAll('.p-product .c-collapsible-panel');
    panels.forEach(function (panel) {
      var summary = panel.querySelector('summary');
      if (!summary) return;

      /* open 属性を常時付与（コンテンツを DOM に保持） */
      panel.setAttribute('open', '');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        panel.classList.toggle('is-open');
      });
    });
  })();

  /* 商品詳細: サムネイルクリックで画像切り替え + アクティブ切り替え */
  (function () {
    var gallery = document.querySelector('.p-product-gallery');
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll('.thumbnails .thumb');
    var slides = gallery.querySelectorAll('.slide');
    var viewport = gallery.querySelector('.viewport');
    var isPC = function () {
      return window.matchMedia('(min-width: 800px)').matches;
    };

    /* 初期状態: 最初のスライドをアクティブに */
    if (slides[0]) slides[0].classList.add('is-active');
    if (thumbs[0]) thumbs[0].classList.add('is-active');

    /* サムネイルクリック */
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        var slide = slides[index];
        if (!slide) return;

        if (isPC()) {
          /* PC: アクティブスライドを切り替え */
          slides.forEach(function (s) {
            s.classList.remove('is-active');
          });
          thumbs.forEach(function (t) {
            t.classList.remove('is-active');
          });
          slide.classList.add('is-active');
          thumb.classList.add('is-active');
        } else if (viewport) {
          /* モバイル: viewport 内を横スクロール */
          viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    });

    /* モバイル: マウスドラッグでスクロール */
    if (viewport) {
      var isDragging = false;
      var startX = 0;
      var scrollStart = 0;

      viewport.addEventListener('mousedown', function (e) {
        if (isPC()) return;
        isDragging = true;
        startX = e.pageX;
        scrollStart = viewport.scrollLeft;
        viewport.style.cursor = 'grabbing';
        viewport.style.scrollSnapType = 'none';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var dx = e.pageX - startX;
        viewport.scrollLeft = scrollStart - dx;
      });

      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        viewport.style.cursor = '';
        viewport.style.scrollSnapType = '';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-search-artworks"] && !Shopify.designMode) return;
  try {
    
  /* 作品を探す: アコーディオンの開閉制御 */
  (function () {
    var panels = document.querySelectorAll(".p-top-search .c-collapsible-panel");
    panels.forEach(function (panel) {
      var details = panel;
      var wrapper = panel.querySelector(".wrapper");

      details.addEventListener("toggle", function () {
        if (details.open) {
          panel.classList.add("is-open");
        } else {
          panel.classList.remove("is-open");
        }
      });

      /* summary クリック時にアニメーション制御 */
      var summary = panel.querySelector("summary");
      if (summary) {
        summary.addEventListener("click", function (e) {
          e.preventDefault();
          if (panel.classList.contains("is-open")) {
            panel.classList.remove("is-open");
            /* アニメーション完了後に details を閉じる */
            setTimeout(function () {
              details.removeAttribute("open");
            }, 600);
          } else {
            details.setAttribute("open", "");
            /* 次フレームで開くアニメーション */
            requestAnimationFrame(function () {
              panel.classList.add("is-open");
            });
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shopping-guide"] && !Shopify.designMode) return;
  try {
    
  /* ショッピングガイド: アコーディオンの開閉制御 */
  (function () {
    var panels = document.querySelectorAll('.p-top-guide .c-collapsible-panel');
    panels.forEach(function (panel) {
      var details = panel;
      var summary = panel.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open')) {
          panel.classList.remove('is-open');
          setTimeout(function () {
            details.removeAttribute('open');
          }, 600);
        } else {
          details.setAttribute('open', '');
          requestAnimationFrame(function () {
            panel.classList.add('is-open');
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
